import {apiImgLvjing, apiAliyunSignPolicy, apiPostobjectcallbackerror} from '@/request/api.js';
import {NProgress} from '@/util/nprogress.js'; // 顶部加载条组件
import {EventBus} from '@/util/eventBus.js';

export default {
  isURL(strUrl) {
    // eslint-disable-next-line no-useless-escape
    var regular = /^\b(((https?|ftp):\/\/)?[-a-z0-9]+(\.[-a-z0-9]+)*\.(?:com|edu|gov|int|mil|net|org|biz|info|name|museum|asia|coop|aero|[a-z][a-z]|((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d))\b(\/[-a-z0-9_:\@&?=+,.!\/~%\$]*)?)$/i
    if (regular.test(strUrl)) {
      return true;
    } else {
      return false;
    }
  },
  //判断是否PC端
  isPc(url) {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      // console.log('手机端');
    } else {
      if (url != '') {
        // window.location.href = url;
      }
    }
  },
  // 存储本地数据
  saveTodos(key, todos) {
    try {
      if (todos) {
        //执行存储
        window.localStorage.setItem(key, JSON.stringify(todos));
      } else {
        //执行删除
        window.localStorage.removeItem(key);
      }
      return true;
    } catch (e) {
      return false;
    }
  },
  // 获取本地数据
  readTodoss(key) {
    try {
      return JSON.parse(window.localStorage.getItem(key) || '[]');
    } catch (e) {
      return JSON.parse('[]');
    }
  },
  // 获取本地数据
  readTodos(key) {
    try {
      return JSON.parse(window.localStorage.getItem(key) || '[]');
      // return 'uUzJ9ejgECzeR86cpe5wbzj2F4rUNpwbzj2F85Gxlv9pSz5HRwxikw77gVmiWWaKAHvGNxn6KmrYAypylURtYnvw4THIUwbzj2Frsaq9g';
      // return JSON.parse(window.localStorage.getItem(key) || '[]');
    } catch (e) {
      return JSON.parse('[]');
    }
  },
  //获取div宽高数字
  getBoxSize(node) {
    if (node) {
      return {
        w: node.clientWidth,
        h: node.clientHeight
      }
    } else {
      return {
        w: 0,
        h: 0
      }
    }
  },
  //判断手机号是否合规
  isPoneAvailable(poneInput) {
    var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
    if (!myreg.test(poneInput)) {
      return false;
    } else {
      return true;
    }
  },
  //减法运算
  subtrNumber(arg1, arg2) {
    var r1, r2, m, n;
    try {
      r1 = arg1.toString().split(".")[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split(".")[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2));
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
  },
  //乘法
  accMulNumber(arg1, arg2) {
    var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length
    } catch (e) {
    }
    try {
      m += s2.split(".")[1].length
    } catch (e) {
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
  },
  //除法
  divideNumber(arg1, arg2) {
    var d1, d2,
      n1 = Number(arg1.toString().replace(".", "")),
      n2 = Number(arg2.toString().replace(".", ""));
    try {
      d1 = arg1.toString().split(".")[1].length;
    } catch (e) {
      d1 = 0;
    }
    try {
      d2 = arg2.toString().split(".")[1].length;
    } catch (e) {
      d2 = 0;
    }
    return this.toFixedNumber((n1 / n2) * Math.pow(10, d2 - d1), 2);
  },
  //加法
  accAddNumber(arg1, arg2) {
    var r1, r2, m;
    try {
      r1 = arg1.toString().split(".")[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split(".")[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    return (arg1 * m + arg2 * m) / m
  },
  // arg以四舍五入的方式保留小数点后n位
  toFixedNumber(arg, n) {
    if (n == 0) {
      return Math.round(arg)
    }
    try {
      var d, carryD, i,
        ds = arg.toString().split('.'),
        len = ds[1].length,
        b0 = '', k = 0
      if (len > n) {
        while (k < n && ds[1].substring(0, ++k) == '0') {
          b0 += '0'
        }
        d = Number(ds[1].substring(0, n))
        carryD = Math.round(Number('0.' + ds[1].substring(n, len)))
        len = (d + carryD).toString().length
        if (len > n) {
          return Number(ds[0]) + 1
        } else if (len == n) {
          return Number(ds[0] + '.' + (d + carryD))
        }
        return Number(ds[0] + '.' + b0 + (d + carryD))
      }
    } catch (e) {
    }
    return arg
  },
  //计算手机端 编辑文字时 文字的div缩放大小
  //文字div的真是大小，渲染div的真实大小
  makeTextBoxStyle(modulesize, viewsize) {
    // 判断是高为计算数据 还是宽为计算数据
    if ((viewsize.w / viewsize.h) > (modulesize.w / modulesize.h)) {
      console.log('以高为参照物');
      //判断原始大小是否已经小于生成的BOX
      if (modulesize.h > viewsize.h) {
        //需要缩放
        const newH = viewsize.h * 0.95;
        const newW = (modulesize.w * newH) / modulesize.h;
        return {w: newW, h: newH};
      } else {
        //不需要缩放
        return {w: parseFloat(modulesize.w), h: parseFloat(modulesize.h)};
      }
    } else {
      console.log('以宽为参照物');
      //判断原始大小是否已经小于生成的BOX
      if (modulesize.w > viewsize.w) {
        //需要缩放
        const newW = viewsize.w * 0.95;
        const newH = (modulesize.h * newW) / modulesize.w;
        return {w: newW, h: newH};
      } else {
        //不需要缩放
        return {w: modulesize.w, h: modulesize.h};
      }
    }
  },

  // 通过比例及真实图片的宽高计算图片的样式 @ 手机端
  // 1图片地址 2图片宽高 3显示容器比列 4图片显示起始点 5图片容器的宽
  makeMobileTupianBoxStyle(path, pathSize, ratio, start, imgBoxSize) {
    let imgHost = process.env.IMAGE_URL;//图片域名
    let imgStyle = process.env.IMAGE_URL_STYLE_PC;//图片样式
    path = imgHost + path + imgStyle;
    let result;
    //生成div的宽高
    //176.315 - 2
    if ((imgBoxSize.w / 190) > (ratio.w / ratio.h)) {
      console.log('以高为参照物');
      //判断原始大小是否已经小于生成的BOX
      if (pathSize.h > 190) {
        //需要缩放
        result = {
          width: ((160 * ratio.w) / ratio.h) + 'px',
          height: 160 + 'px'
        };
      } else {
        //不需要缩放
        result = {width: pathSize.w + 'px', height: pathSize.h + 'px'};
      }
    } else {
      //判断原始大小是否已经小于生成的BOX
      if (pathSize.w > imgBoxSize.w) {
        console.log(11);
        //需要缩放
        const newW = imgBoxSize.w - 55;
        const newH = (ratio.h * newW) / ratio.w;
        result = {width: newW + 'px', height: newH + 'px'};
      } else {
        //不需要缩放
        result = {width: pathSize.w + 'px', height: pathSize.h + 'px'};
      }
    }
    //计算是宽还是高100%
    if ((ratio.w / ratio.h) > (pathSize.w / pathSize.h)) {
      //宽设置为100%
      result['background-image'] = 'url(' + path + ')';
      // result['background-size'] = '100% auto';
      result['background-size'] = (100 + start.zoom) + '% auto';
      result['background-color'] = '#EDF0F2';
      result['background-repeat'] = 'no-repeat';
      // result['background-position'] = '0px '+(start*1)+'%';
      result['background-position'] = (start.xpos * 1) + '% ' + (start.ypos * 1) + '%';
    } else {
      //高设置为100%
      result['background-image'] = 'url(' + path + ')';
      // result['background-size'] = 'auto 100%';
      result['background-size'] = 'auto ' + (100 + start.zoom) + '%';
      result['background-color'] = '#EDF0F2';
      result['background-repeat'] = 'no-repeat';
      // result['background-position'] = (start*1)+'% 0px';
      result['background-position'] = (start.xpos * 1) + '% ' + (start.ypos * 1) + '%';
    }
    // console.log(result);
    return result;
  },
  // 通过比例及真实图片的宽高计算图片的样式
  // 1图片地址 2图片宽高 3显示容器比列 4图片显示起始点 5图片容器的宽
  makeTupianBoxStyle(path, pathSize, ratio, start, imgBoxSize) {
    let imgHost = process.env.IMAGE_URL;//图片域名
    let imgStyle = process.env.IMAGE_URL_STYLE_PC;//图片样式
    path = imgHost + path + imgStyle;
    let result;
    //生成div的宽高
    if (ratio.h >= ratio.w) {
      result = {
        width: ((150 * ratio.w) / ratio.h) + 'px',
        height: 150 + 'px'
      };
    } else {
      result = {
        width: imgBoxSize.w + 'px',
        height: ((imgBoxSize.w * ratio.h) / ratio.w) + 'px'
      };
    }
    //计算是宽还是高100%
    if ((ratio.w / ratio.h) > (pathSize.w / pathSize.h)) {
      //宽设置为100%
      result['background-image'] = 'url(' + path + ')';
      // result['background-size'] = '100% auto';
      result['background-size'] = (100 + start.zoom) + '% auto';
      result['background-color'] = '#EDF0F2';
      result['background-repeat'] = 'no-repeat';
      // result['background-position'] = '0px '+(start*1)+'%';
      result['background-position'] = (start.xpos * 1) + '% ' + (start.ypos * 1) + '%';
    } else {
      //高设置为100%
      result['background-image'] = 'url(' + path + ')';
      // result['background-size'] = 'auto 100%';
      result['background-size'] = 'auto ' + (100 + start.zoom) + '%';
      result['background-color'] = '#EDF0F2';
      result['background-repeat'] = 'no-repeat';
      // result['background-position'] = (start*1)+'% 0px';
      result['background-position'] = (start.xpos * 1) + '% ' + (start.ypos * 1) + '%';
    }
    // console.log(result);
    return result;
  },
  //通过box计算组件显示的的宽高
  // 容器窗口的宽高  书本类型的宽高
  calculateSize(viewsize, modulesizeJson, percentage) {
    //转化原始box的数据
    const modulesize = JSON.parse(modulesizeJson);
    if ((viewsize.w / viewsize.h) > (modulesize.w / modulesize.h)) {
      console.log('以高为参照物');
      //判断原始大小是否已经小于生成的BOX
      if (modulesize.h > (viewsize.h * percentage)) {
        //需要缩放
        const newH = viewsize.h * percentage;
        const newW = (modulesize.w * newH) / modulesize.h;
        return {w: newW, h: newH};
      } else {
        //不需要缩放
        return {w: parseFloat(modulesize.w), h: parseFloat(modulesize.h)};
      }
    } else {
      console.log('以宽为参照物');
      //判断原始大小是否已经小于生成的BOX
      if (modulesize.w > (viewsize.w * percentage)) {
        //需要缩放
        const newW = viewsize.w * percentage;
        const newH = (modulesize.h * newW) / modulesize.w;
        return {w: newW, h: newH};
      } else {
        //不需要缩放
        return {w: modulesize.w, h: modulesize.h};
      }
    }

    // 判断是高为计算数据 还是宽为计算数据
    // if((viewsize.w/viewsize.h) > (modulesize.w/modulesize.h)){
    //     console.log('以高为参照物');
    //     //判断原始大小是否已经小于生成的BOX
    //     if(modulesize.h>viewsize.h){
    //         //需要缩放
    //         const newH = Math.floor(viewsize.h * 0.8);
    //         const newW = Math.floor((modulesize.w * newH) / modulesize.h);
    //         return {w:parseFloat(newW),h:parseFloat(newH)};
    //     }else{
    //         //不需要缩放
    //         return {w:parseFloat(modulesize.w),h:parseFloat(modulesize.h)};
    //     }
    // }else{
    //     console.log('以宽为参照物');
    //     //判断原始大小是否已经小于生成的BOX
    //     if(modulesize.w>viewsize.w){
    //         //需要缩放
    //         const newW = Math.floor(viewsize.w * 0.8);
    //         const newH = Math.floor((modulesize.h * newW) / modulesize.w);
    //         return {w:parseFloat(newW),h:parseFloat(newH)};
    //     }else{
    //         //不需要缩放
    //         return {w:parseFloat(modulesize.w),h:parseFloat(modulesize.h)};
    //     }
    // }
  },
  //内容页的宽高值及缩放值计算
  //显示的宽高 ， 计算宽高还是缩放 ， 真实宽高
  calculateMixinSize(boxSize, type, size) {
    const modulesize = size;
    if (type === 1) {
      if (boxSize.w != null) {
        //通过宽
        const h = (boxSize.w * modulesize.h) / modulesize.w;
        return {w: boxSize.w, h: h};
      } else {
        //通过高
        const w = (boxSize.h * modulesize.w) / modulesize.h;
        return {w: w, h: boxSize.h};
      }
    } else {
      if (boxSize.w != null) {
        //通过宽
        const scale = boxSize.w / modulesize.w;
        return scale;
      } else {
        //通过高
        const scale = boxSize.h / modulesize.h;
        return scale;
      }
    }
  },
  // div图片背景
  divBackground(info, field) {
    let path = info.data[field].path;
    if (path) {
      let imgHost = process.env.IMAGE_URL;
      let imgStyle = process.env.IMAGE_URL_STYLE_PC;//图片样式
      let paths = imgHost + path + imgStyle;
      return {
        src: paths,
        error: '',
        loading: ''
      };
    } else {
      return '';
    }
  },
  // 通过固定的显示区域宽高  与  确定的图片宽高  生成背景样式
  // 固定宽高 / 真实图片宽高 / 图片起始点 / 图片地址
  divStyle(divCss, info, field) {
    let result = {};
    let path = info.data[field].path;
    if (info && path) {
      let imgCss = info.data[field].size;
      let start = info.data[field].start;
      let paths = process.env.IMAGE_URL + path;
      //计算是宽还是高100%
      if ((divCss.w / divCss.h) > (imgCss.w / imgCss.h)) {
        //宽设置为100%
        result['background-size'] = (100 + start.zoom) + '% auto';
        result['background-color'] = this.enters();
        result['background-repeat'] = 'no-repeat';
        result['background-position'] = (start.xpos * 1) + '% ' + (start.ypos * 1) + '%';
      } else {
        //高设置为100%
        result['background-size'] = 'auto ' + (100 + start.zoom) + '%';
        result['background-color'] = this.enters();
        result['background-repeat'] = 'no-repeat';
        result['background-position'] = (start.xpos * 1) + '% ' + (start.ypos * 1) + '%';
      }
    } else {
      result['background-size'] = 'cover';
      result['background-color'] = this.enters();
      result['background-repeat'] = 'no-repeat';
    }
    return result;
  },
  enters() {
    const arr = ['rgba(242,242,242)'];
    return arr[Math.floor((Math.random() * arr.length))];
  },
  //判断两个对象是否完全相同
  isObjectValueEqual(a, b) {
    const aProps = Object.keys(a);
    const bProps = Object.keys(b);
    if (aProps.length !== bProps.length) {
      return true;
    }
    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];
      var propA = a[propName];
      var propB = b[propName];
      if (propA !== propB) {
        return true;
      } else {

      }
    }
    return false
  },
  // 图片编辑的图片处理
  dealMakeTupian(ob, pageInfo) {
    const imgPath = pageInfo.data[ob.field]['path'];
    var path = '';
    var pathSize = '';
    var pathContent = '';
    var pathUrl = '';
    if (imgPath) {
      // (预定义图片包含 '/default/' 字符)
      if (imgPath.search(/\/default\//) === -1) {
        // 如果是【正常图片】的话 则 拼接为完全地址路径
        path = imgPath;
        //图片的大小
        pathSize = pageInfo.data[ob.field]['size'];
        //描述
        pathContent = pageInfo.data[ob.field]['content'];
        //url地址
        pathUrl = pageInfo.data[ob.field]['url'];
      } else {
        // 如果是【系统图片】的话则为空
        path = '';
        pathSize = null;
        pathContent = '';
        pathUrl = '';
      }
    } else {
      // 如果【无图片】的话则为空
      path = ''; // 图片
      pathSize = null;
      pathContent = '';
      pathUrl = '';
    }
    return {path: path, pathSize: pathSize, pathContent: pathContent, pathUrl: pathUrl};
  },
  //图片警告
  showWarning(info, str) {
    // 如果不为空并且不是系统图片
    if (info.data[str].path != '' && info.data[str].path.search(/\/default\//) == -1) {
      //获取允许的最小尺寸
      var validate = info.module_validata[str];
      //获取原始尺寸
      var size = info.data[str].size;
      //获取样式设置
      var start = info.data[str].start;
      //提取
      var minW = validate.w;
      var minH = validate.h;
      var fileW = size.w;
      var fileH = size.h;
      //判断是否显示警告
      if (start.zoom == 0) {
        if (fileW < minW || fileH < minH) {
          return 1;
        }
      } else {
        var xLength = fileW - (fileW * (start.zoom * 0.01));
        var yLength = fileH - (fileH * (start.zoom * 0.01));
        if (xLength < minW || yLength < minH) {
          return 3;
        }
      }
    }
    return false;
  },
  //计算图片的鼠标移动处理 - 触点处理
  // 1鼠标点击的坐标 2鼠标移动的实时坐标 3旧的鼠标坐标 4当前图片容器的比例 5当前图片的尺寸 6当前图片的起始点 7容器的宽高
  onClickMouveFun(oldOb, newOb, oldXy, ratio, pathSize, start, imgBoxSize) {
    // console.log(oldOb);
    // console.log(newOb);
    // console.log(oldXy);
    // console.log(ratio);
    // console.log(pathSize);
    // console.log(start);
    // oldOb = Number(oldOb);
    // newOb = Number(newOb);
    // oldXy = Number(oldXy);
    //判断有没有旧的数据
    if (oldXy != null) {
      oldOb = {
        disX: oldXy.newX,
        disY: oldXy.newY
      };
    }

    // 获取容器的宽高 / 获取图片的真实宽高 / 获取放大的比例 / 通过容器宽高与放大后的图片宽高计算xy的活动范围
    let chaY = 0; // 初始化y轴差
    let chaX = 0; // 初始化x轴差
    chaY = oldOb.disY - newOb.newY; // y轴差
    chaX = oldOb.disX - newOb.newX; // x轴差

    //计算跨度
    //通过最小图片的宽高 与 容器的宽 计算容器的宽高
    let boxSize = {
      w: imgBoxSize.w * 100 * 0.01,
      h: ((imgBoxSize.w * ratio.h) / ratio.w) * 100 * 0.01
    };
    //图片嵌套的宽高
    let boxImageSize;
    if ((ratio.w / ratio.h) > (pathSize.w / pathSize.h)) {
      boxImageSize = {
        w: boxSize.w * (100 + start.zoom) * 0.01,
        h: ((pathSize.h * boxSize.w) / pathSize.w) * (100 + start.zoom) * 0.01
      };
    } else {
      boxImageSize = {
        w: ((pathSize.w * boxSize.h) / pathSize.h) * (100 + start.zoom) * 0.01,
        h: boxSize.h * (100 + start.zoom) * 0.01
      };
    }
    //获取差价
    var xSudu = 0;
    var ySudu = 0;
    let ws = boxImageSize.w - boxSize.w;
    let hs = boxImageSize.h - boxSize.h;
    if (ws != 0) {
      xSudu = 5 / ws * 10 * 4;
    }
    if (hs != 0) {
      ySudu = 5 / hs * 10 * 4;
    }
    // console.log(ws,hs);
    console.log(xSudu, ySudu);
    // console.log(ws/5,hs/5);
    // console.log(start,boxSize,boxImageSize);
    //计算图片嵌套后的宽高
    // xSudu = 1;
    // ySudu = 1;
    // if((ratio.w/ratio.h) > (pathSize.w/pathSize.h)){
    //     ySudu = (pathSize.h * ySudu / pathSize.w) * 5;
    // }else{
    //     xSudu = (pathSize.w * xSudu / pathSize.h) * 5;
    // }
    // console.log(xSudu,ySudu);
    if (chaY > 0) {
      chaY = ySudu; // 上移动
    } else if (chaY < 0) {
      chaY = ySudu * -1; // 下移动
    } else {
      chaY = 0;
    }
    if (chaX > 0) {
      chaX = xSudu; // 左移动
    } else if (chaX < 0) {
      chaX = xSudu * -1; // 右移动
    } else {
      chaX = 0;
    }

    var newStart = {};
    //判断是否放大了
    if (start.zoom == 0) {
      // 如果没有放大
      if ((ratio.w / ratio.h) > (pathSize.w / pathSize.h)) {
        //xpos 永远为0
        newStart.xpos = 0;
        newStart.ypos = start.ypos + chaY;
      } else {
        //ypos 永远为0
        newStart.ypos = 0;
        newStart.xpos = start.xpos + chaX;
      }
    } else {
      //如果放大了
      if ((ratio.w / ratio.h) > (pathSize.w / pathSize.h)) {
        //xpos 永远为0
        newStart.xpos = start.xpos + chaX;
        newStart.ypos = start.ypos + chaY;
      } else {
        //ypos 永远为0
        newStart.ypos = start.ypos + chaY;
        newStart.xpos = start.xpos + chaX;
      }
    }
    newStart.zoom = start.zoom;
    //防止水平出界
    if (newStart.xpos > 100) {
      newStart.xpos = 100;
    } else if (newStart.xpos < 0) {
      newStart.xpos = 0;
    } else {

    }
    //防止垂直出界
    if (newStart.ypos > 100) {
      newStart.ypos = 100;
    } else if (newStart.ypos < 0) {
      newStart.ypos = 0;
    } else {

    }
    // 判断是计算x还是y
    // if((ratio.w/ratio.h) > (pathSize.w/pathSize.h)){
    //     //计算Y轴的距离
    //     cha = oldOb.disY-newOb.newY;
    // }else{
    //     //计算X轴的距离
    //     cha = oldOb.disX-newOb.newX;
    // }
    // if(cha>0){
    //     cha = 2;
    // }else{
    //     cha = -2;
    // }
    // if((start+cha)>=100){
    //     start = 100;
    // }else if((start+cha)<0){
    //     start = 0;
    // }else{
    //     start = start+cha;
    // }
    //记录旧的坐标
    return newStart;
  },
  //回调函数 - 获取上下的图片
  callBackImages(bookList, id) {
    // 获取坐标
    const infoOb = bookList.find(item => {
      return item.id == id
    });
    const index = bookList.indexOf(infoOb);
    var imgArr = [];
    // 页面列表 - 起始index - 次数 - 回调的函数
    return this.callBackImagesArr(bookList, index, 0, this.callBackImagesArr, imgArr);
  },
  callBackImagesArr(bookList, index, speed, callBackImagesArr, imgArr) {
    var data;
    if (imgArr.length >= 4 || (bookList[index + speed] == undefined && bookList[index - speed] == undefined)) {
      console.log(imgArr);
      return imgArr;
    } else {
      if (((index + speed) <= (bookList.length - 1)) && (bookList[index + speed] != undefined)) {
        data = bookList[index + speed]['data'];
        Object.keys(data).forEach(function (key) {
          //如果有路径则将图片取下
          if (data[key]['path']) {
            //如果是预定义图片 及 二维码 则不加入数组
            if (data[key]['path'].search(/\/default\//) === -1 && data[key]['path'].search(/@qrcode\./) === -1) {
              imgArr.push(data[key]['path']);
            }
          }
        })
      }
      if ((index - speed >= 0) && (bookList[index - speed] != undefined)) {
        data = bookList[index - speed]['data'];
        Object.keys(data).forEach(function (key) {
          //如果有路径则将图片取下
          if (data[key]['path']) {
            //如果是预定义图片 及 二维码 则不加入数组
            if (data[key]['path'].search(/\/default\//) === -1 && data[key]['path'].search(/@qrcode\./) === -1) {
              imgArr.push(data[key]['path']);
            }
          }
        })
      }
      //数组去重
      imgArr = [...new Set(imgArr)];
      speed++;
      return callBackImagesArr(bookList, index, speed, callBackImagesArr, imgArr);
    }
  },
  //滚轮放大缩小
  onMousewheel(type, start) {
    if (type == 'up') {
      //放大
      start.zoom += 5;
    } else {
      //缩小
      start.zoom -= 5;
    }
    if (start.zoom < 0) {
      start.zoom = 0;
    } else if (start.zoom > 100) {
      start.zoom = 100;
    } else {

    }
    console.log(start);
  },
  // 图片滤镜处理
  // 获取图片的宽高
  // 执行更换滤镜 @新的滤镜类型 @图片的完整地址 @当前图片的滤镜类型 @所属书本的加密str
  imageFilter(filter, path, tail, str) {
    return new Promise(function (resolve, reject) {
      //远程获取base64编码
      apiImgLvjing({filter, path, str}).then(respo => {
        //得到base64编码
        resolve(respo);
      });
    });
  },
  // axios结果处理
  disposeResult(ob, that) {
    if (ob.state === 2) {
      that.$message.showMsgBox({
        type: 'success',
        content: ob.message
      });
    } else if (ob.state === 3) {
      that.$message.showMsgBox({
        type: 'warning',
        content: ob.message
      });
      //请登录
      that.$login.showLoginBox();
    } else if (ob.state === 4) {
      that.$message.showMsgBox({
        type: 'warning',
        content: ob.message
      });
    } else if (ob.state === 5) {
      that.$message.showMsgBox({
        type: 'danger',
        content: ob.message
      });
    } else if (ob.state === 1) {

    } else {

    }
  },
  //获取总页数
  getPageCount(arr, info) {
    var number = 0;
    if (arr) {
      arr.forEach(function (app, index) {
        if (app.mold != 1 && app.mold != 2 && app.mold != 5) {
          number++;
        }
      });
      // 精装照片书 * 2
      if (info.id == 1) {
        number = number * 2;
      }
      // 横款照片书
      if (info.id == 2) {
        // number = number;
      }
      // 锁线经典照片书 * 2
      if (info.id == 3) {
        number = number * 2;
      }
      //时光日历 + 1
      if (info.id == 4) {
        number = number + 1;
      }
      if (info.id == 5) {
        // number = number;
      }
      if (info.id == 6) {
        // number = number;
      }
    }
    return number;
  },
  //计算Pagehead 的str
  calculatePageHeadStr(typeInfo, bookList, info, index) {
    var str = '';
    if (typeInfo['id'] == 1) {
      // 精装照片书 = 双页
      str = this.getDoubleStr(typeInfo, bookList, info, index);
    } else if (typeInfo['id'] == 2) {
      // 横款照片书 = 单页
      str = this.getSingleStr(typeInfo, bookList, info, index);
    } else if (typeInfo['id'] == 3) {
      // 经典照片书
      str = this.getDoubleStr(typeInfo, bookList, info, index);
    } else if (typeInfo['id'] == 4) {
      // 日历
      str = this.getCalendarTitle(index, info);
    } else if (typeInfo['id'] == 5) {
      // 日历
      str = '时光摆台';
    } else if (typeInfo['id'] == 6) {
      // 经典照片书 = 单页
      str = this.getSingleStr(typeInfo, bookList, info, index);
    } else {
      str = '未知';
    }
    return str;
  },
  // 单页形式的 title
  getDoubleStr(typeInfo, bookList, info, index) {
    var str = '';
    if (info['mold'] == 1) {
      str = '封面';
    } else if (info['mold'] == 2) {
      str = '内衬 / 序言';
    } else if (info['mold'] == 3) {
      str = '错误的页面MOLD3';
    } else if (info['mold'] == 4) {
      var pageNumber = 0;
      // 计算内页第几页
      try {
        bookList.forEach(function (arr, key) {
          if (key > index) {
            // 到位置了 则断掉循环
            throw new Error('EndIterative');
          } else if (key <= index && arr['mold'] == 4) {
            pageNumber++;
          } else {
            // 没到对应位置 并且不是内页
          }
          if (arr['mold'] == 4) {

          }
        });
      } catch (e) {
        if (e.message != 'EndIterative') {
          throw e;
        }
      }
      ;
      str = '第 ' + (pageNumber * 2 - 1) + ' 页 / ' + '第 ' + (pageNumber * 2) + ' 页';
    } else if (info['mold'] == 5) {
      str = '封底';
    } else {
      str = '错误的页面MOLD6';
      //双页没有封底
    }
    return str;
  },
  // 单页形式的 title
  getSingleStr(typeInfo, bookList, info, index) {
    var str = '';
    if (info['mold'] == 1) {
      str = '封面';
    } else if (info['mold'] == 2) {
      str = '序言';
    } else if (info['mold'] == 3) {
      str = '目录';
    } else if (info['mold'] == 4) {
      var pageNumber = 0;
      // 计算内页第几页
      try {
        bookList.forEach(function (arr, key) {
          if (key > index) {
            // 到位置了 则断掉循环
            throw new Error('EndIterative');
          } else if (key <= index && arr['mold'] == 4) {
            pageNumber++;
          } else {
            // 没到对应位置 并且不是内页
          }
          if (arr['mold'] == 4) {

          }
        });
      } catch (e) {
        if (e.message != 'EndIterative') {
          throw e;
        }
      }
      ;
      str = '第 ' + pageNumber + ' 页';
    } else if (info['mold'] == 5) {
      // 单页有封底
      str = '封底';
    } else {
      str = '错误的页面';
    }
    return str;
  },
  // 日历 title
  getCalendarTitle(index, info) {
    var str = '';
    switch (index) {
      case 0:
        str = '封面';
        break;
      case 1:
        str = '2021 · 一月';
        break;
      case 2:
        str = '2021 · 一月 · 反面';
        break;
      case 3:
        str = '2021 · 二月';
        break;
      case 4:
        str = '2021 · 二月 · 反面';
        break;
      case 5:
        str = '2021 · 三月';
        break;
      case 6:
        str = '2021 · 三月 · 反面';
        break;
      case 7:
        str = '2021 · 四月';
        break;
      case 8:
        str = '2021 · 四月 · 反面';
        break;
      case 9:
        str = '2021 · 五月';
        break;
      case 10:
        str = '2021 · 五月 · 反面';
        break;
      case 11:
        str = '2021 · 六月';
        break;
      case 12:
        str = '2021 · 六月 · 反面';
        break;
      case 13:
        str = '2021 · 七月';
        break;
      case 14:
        str = '2021 · 七月 · 反面';
        break;
      case 15:
        str = '2021 · 八月';
        break;
      case 16:
        str = '2021 · 八月 · 反面';
        break;
      case 17:
        str = '2021 · 九月';
        break;
      case 18:
        str = '2021 · 九月 · 反面';
        break;
      case 19:
        str = '2021 · 十月';
        break;
      case 20:
        str = '2021 · 十月 · 反面';
        break;
      case 21:
        str = '2021 · 十一月';
        break;
      case 22:
        str = '2021 · 十一月 · 反面';
        break;
      case 23:
        str = '2021 · 十二月';
        break;
      case 24:
        str = '2021 · 十二月 · 反面';
        break;
      default:
        str = '错误的页面';
    }
    return str;
  },
  // 是否显示下移
  calculateShowDown(typeInfo, bookList, info, index) {
    // 1封面 2序言 3目录 4内页 5封底
    if (info['mold'] == 1 || info['mold'] == 2 || info['mold'] == 5 || info['mold'] == 6) {
      return false;
    } else {
      //获取当前的mold类型
      if (bookList[index + 1] == undefined || bookList[index + 1]['mold'] != info['mold']) {
        return false;
      } else {
        return true;
      }
    }
  },
  // 是否显示上移
  calculateShowUp(typeInfo, bookList, info, index) {
    // 1封面 2序言 3目录 4内页 5封底
    if (info['mold'] == 1 || info['mold'] == 2 || info['mold'] == 5 || info['mold'] == 6) {
      return false;
    } else {
      //获取当前的mold类型
      if (bookList[index - 1] == undefined || bookList[index - 1]['mold'] != info['mold']) {
        return false;
      } else {
        return true;
      }
    }
  },
  // 是否显示删除
  calculateShowDel(typeInfo, bookList, info, index) {
    // 1封面 2序言 3目录 4内页 5封底 6是日历性质
    if (info['mold'] == 1 || info['mold'] == 2 || info['mold'] == 5 || info['mold'] == 6) {
      return false;
    } else {
      //目录和内页不能全部删除
      var thisMold = info['mold'];
      var runTime = bookList.filter(function (item, index) {
        return item['mold'] == thisMold;
      });
      if (runTime.length > 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  // 是否显示添加
  calculateShowAdd(typeInfo, bookList, info, index) {
    // 1封面 2序言 3目录 4内页 5封底 6是日历性质
    if (info['mold'] == 1 || info['mold'] == 2 || info['mold'] == 5 || info['mold'] == 6) {
      return false;
    } else {
      //目录和内页不能全部删除
      return true;
    }
  },
  //缓冲效果 容器,目标
  moveScroll(obj, box) {
    clearInterval(obj.time_id);
    var target = box.offsetTop - 20;
    var objHeight = obj.scrollHeight;
    var boxHeight = box.scrollHeight;
    if (target < 0) {
      target = 0;
    }
    if ((obj.scrollHeight - box.scrollHeight - 50) <= target) {
      target = obj.scrollHeight - obj.offsetHeight;
    }
    obj.time_id = setInterval(function () {
      var iCurr = obj.scrollTop;
      var speed = (target - iCurr) / 3;
      speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
      if (target == iCurr) {
        clearInterval(obj.time_id);
      }
      document.getElementById('pageScrollBox').scrollTop = obj.scrollTop + speed;
    }, 40);
  },
  //视图页面的缓冲
  moveScrollLogue(obj) {
    clearInterval(obj.time_id);
    var target = obj.scrollHeight;
    if (target < 0) {
      target = 0;
    }
    target = obj.scrollHeight - obj.offsetHeight;
    obj.time_id = setInterval(function () {
      var iCurr = obj.scrollTop;
      var speed = (target - iCurr) / 3;
      speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
      if (target == iCurr) {
        clearInterval(obj.time_id);
      }
      document.getElementById('catalogueScrollBox').scrollTop = obj.scrollTop + speed;
    }, 40);
  },
  getUseCount(arr) {
    var number = 0;
    if (arr) {
      arr.forEach(function (app, index) {
        let imgArr = app.data;
        Object.keys(imgArr).forEach(function (key) {
          //如果有路径则将图片取下
          if (imgArr[key]['path']) {
            let imgPath = imgArr[key]['path'];
            //如果是预定义图片则不加入闲置队列
            if (imgPath.search(/\/default\//) === -1) {
              number++;
            }
          }
        })
      });
    }
    return number;
  },
  getXianCount(arr) {
    var number = 0;
    if (arr) {
      arr.forEach(function (app, index) {
        if (app.is_del !== 1) {
          number++;
        }
      });
    }
    return number;
  },
  //单独上传图片
  makeTupianImageUpload(vueOb, files, data, isSource) {
    // 获取aliyunOSS 的 签名和Policy
    apiAliyunSignPolicy({str: data.str}).then(ob => {
      if (ob.state == 1) {
        console.log(files, 'files');
        console.log(data, 'data');
        console.log(ob, 'ob');
        console.log(data.str, 'data.str');
        //拿到了sign & policy
        var fileName = this.stringToHex(ob.data.user_md5) + '.' + this.getFileType(files.name);
        var formData = new FormData();
        var errorPostobjectFun = this.errorPostobject;
        formData.append('key', fileName);  //文件名 - key
        formData.append('policy', ob.data.policy);  //所属的书本加密串
        formData.append('OSSAccessKeyId', ob.data.accessid);  //所属的accessKeyId
        formData.append('success_action_status', 200);  //约定状态
        formData.append('callback', ob.data.callback);  //回调
        formData.append('signature', ob.data.signature);  //签名
        formData.append('x:book_id', data.str);  //所属的书本加密串
        formData.append('file', files);  //文件
        $.ajax({
          url: ob.data.host,
          type: 'POST',
          // headers:{Authorization:data.token},
          data: formData,//文件以formData形式传入
          cache: false,
          processData: false,
          //必须false才会自动加上正确的Content-Type
          contentType: false,
          dataType: 'json',
          //监听用于上传显示进度
          success: function (datas) {
            if (datas.state == 2) {
              //初始化二维码的内容
              vueOb.delQrocde();
              if (isSource == 'reload') {
                //将老的加入闲置队列
                vueOb.uninstallPageImage({remove: '', join: vueOb.path, size: vueOb.pathSize});//加入一个
              }
              // //更新本地的
              vueOb.path = datas.data.path;
              vueOb.start = {xpos: 0, ypos: 0, zoom: 0};
              vueOb.pathSize = datas.data.size;
              //同步图片数据到pages队列中
              vueOb.savePageImageData();
              // 取消上传中的状态
              vueOb.$message.showMsgBox({
                type: 'success',
                content: '上传成功'
              });
              NProgress.done();
              vueOb.is_loading = false;
              EventBus.$emit('loadingFun', false);//可以继续操作页面了
            } else {
              //如果失败了 那么需要将失败的地址发送至 错误图片 接口
              errorPostobjectFun(fileName, data.str, vueOb);
              vueOb.$message.showMsgBox({
                type: 'warning',
                content: '上传失败111'
              });
              NProgress.done();
              vueOb.is_loading = false;
              EventBus.$emit('loadingFun', false);//可以继续操作页面了
            }
          },
          error: function (xhr) {
            console.log('跑到了这里来了');
            //如果失败了 那么需要将失败的地址发送至 错误图片 接口
            errorPostobjectFun(fileName, data.str, vueOb);
            vueOb.$message.showMsgBox({
              type: 'warning',
              content: '上传失败222'
            });
            NProgress.done();
            vueOb.is_loading = false;
            EventBus.$emit('loadingFun', false);//可以继续操作页面了
          }
        });
      } else {
        vueOb.$message.showMsgBox({
          type: 'warning',
          content: '身份验证失败'
        });
        NProgress.done();
        vueOb.is_loading = false;
        EventBus.$emit('loadingFun', false);//可以继续操作页面了
      }
    }).catch(ob => {
      vueOb.$message.showMsgBox({
        type: 'warning',
        content: '身份验证失败'
      });
      NProgress.done();
      vueOb.is_loading = false;
      EventBus.$emit('loadingFun', false);//可以继续操作页面了
    });
  },
  //图片上传失败调取错误接口的操作
  errorPostobject(path, str, vueOb) {
    //只报错一次 - 因为有oss的对象枚举功能查出游离对象
    apiPostobjectcallbackerror({path: path, str: str}).then(ob => {
    }).catch(ob => {
    });
  },
  //获取十六进制字符串
  stringToHex(str) {
    var strr = '';
    for (var i = 0; i < 3; i++) {
      var number = Math.ceil(Math.random() * 9) + '';
      strr += number;
    }
    var dateOb = new Date().getTime();
    return str + '/' + ((dateOb + strr).split('').reverse().join(''));
  },
  //随机数
  randomStr(n) {
    var str = '';
    for (var i = 0; i < n; i++) {
      var number = Math.ceil(Math.random() * 9) + '';
      str += number;
    }
    return str;
  },
  //获取文件后缀名
  getFileType(filePath) {
    var startIndex = filePath.lastIndexOf(".");
    if (startIndex != -1) {
      return filePath.substring(startIndex + 1, filePath.length).toLowerCase();
    } else {
      return "";
    }
  },
  // 循环遍历队列上传图片
  queueImagesUpload(vueOb, files, data) {
    //获取aliyunOSS的签名和Policy
    apiAliyunSignPolicy({str: data.str}).then(ob => {
      if (ob.state == 1) {
        //下标
        let i = 0;
        //第几个
        let j = 0;
        //已成功几个
        let success = 0;
        //总大小
        let sfileSize = 0;
        //获取当前选择的文件对象
        let ss;
        if (files.length === undefined) {
          let FileList = [files];
          ss = FileList;
        } else {
          ss = files;
        }
        // //返回总大小
        for (var m = 0; m < ss.length; m++) {  //循环添加进度条
          sfileSize += ss[m].size;
        }
        vueOb.sfileSize = sfileSize;
        //文件总个数
        vueOb.allNumber = ss.length;
        //已上传个数
        vueOb.enterNumber = success;
        //上传百分比
        vueOb.progress = 0;
        let sendAjax = this.sendAjax;
        //上传中状态
        vueOb.is_loading = 2;
        return sendAjax(j, success, ss, vueOb, files, data, sendAjax, ob, this.stringToHex, this.getFileType, this.errorPostobject);
      } else {
        vueOb.$message.showMsgBox({
          type: 'warning',
          content: '身份验证失败1'
        });
        NProgress.done();
        vueOb.is_loading = 1;
      }
    }).catch(ob => {
      console.log(ob);
      vueOb.$message.showMsgBox({
        type: 'warning',
        content: '身份验证失败2'
      });
      NProgress.done();
      vueOb.is_loading = 1;
    });
  },
  sendAjax(j, success, ss, vueOb, files, data, sendAjax, ob, stringToHex, getFileType, errorPostobject) {
    vueOb.errorNumber = j - success;
    //采用递归的方式循环发送ajax请求
    if (j >= ss.length) {
      vueOb.is_loading = 3;
      if (vueOb.errorNumber != 0) {
        vueOb.$message.showMsgBox({
          type: 'warning',
          content: ' 额！' + vueOb.errorNumber + ' 张图上传失败'
        });
      }
      setTimeout(function () {
        vueOb.is_loading = 1;
        console.log(success, j);
        NProgress.done();
        EventBus.$emit('loadingFun', false);//可以继续操作页面了
      }, 1000);
      //终止
      return true;
    }
    var fileName = stringToHex(ob.data.user_md5) + '.' + getFileType(ss[j].name);
    var formData = new FormData();
    var errorPostobjectFun = errorPostobject;

    formData.append('key', fileName);  //文件名 - key
    formData.append('policy', ob.data.policy);  //所属的书本加密串
    formData.append('OSSAccessKeyId', ob.data.accessid);  //所属的accessKeyId
    formData.append('success_action_status', 200);  //约定状态
    formData.append('callback', ob.data.callback);  //回调
    formData.append('signature', ob.data.signature);  //签名
    formData.append('x:book_id', data.str);  //所属的书本加密串
    formData.append('file', ss[j]);  //文件

    $.ajax({
      url: ob.data.host,
      type: 'POST',
      // headers:{Authorization:data.token},
      data: formData,//文件以formData形式传入
      cache: false,
      processData: false,
      //必须false才会自动加上正确的Content-Type
      contentType: false,
      dataType: 'json',
      //监听用于上传显示进度
      success: function (datas) {
        //当上传成功的时候
        if (datas.state == 2) {
          // 更新已上传的大小
          vueOb.progress += ss[j].size;
          // 更新成功的个数
          success++
          vueOb.enterNumber = success;
          //追加闲置队列
          vueOb.uninstallPageImage({remove: '', join: process.env.IMAGE_URL + datas.data.path, size: datas.data.size});//加入一个
        } else {
          //如果失败了 那么需要将失败的地址发送至 错误图片 接口
          errorPostobjectFun(fileName, data.str, vueOb);
        }
        //递归条件
        j++;
        return sendAjax(j, success, ss, vueOb, files, data, sendAjax, ob, stringToHex, getFileType, errorPostobject);
      },
      error: function (xhr) {
        //如果失败了 那么需要将失败的地址发送至 错误图片 接口
        errorPostobjectFun(fileName, data.str, vueOb);
        //递归条件
        j++;
        return sendAjax(j, success, ss, vueOb, files, data, sendAjax, ob, stringToHex, getFileType, errorPostobject);
      }
    });
  },
  //点击事件
  clickMouseActive(target) {
    //初始化
    $('.lucencyTxt').removeClass('mouseActive');
    $('.lucencyImg').removeClass('mouseActive');
    if (target) {
      target.classList.add('mouseActive');
    }
  },
  //获取优惠券数据
  userDiscountList(that, obj) {
    console.log(that, obj);
  }
}



// WEBPACK FOOTER //
// ./src/util/commons.js